// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"42a44b9b","488":"39d03a3c","551":"d9c028ea","732":"0f57e330","977":"5edf6698"}[chunkId] + ".chunk.js";
};